export function excludeUndefinedOrEmptyObjectJsonReplacer(
    this: { [key: string | number]: object },
    key: string,
    value: unknown
) {
    const originalValue: unknown = this[key];
    if (originalValue == undefined || (typeof originalValue === "object" && Object.keys(originalValue).length == 0)) {
        return undefined;
    }
    return value;
}
